"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const Confirm_1 = require("./Confirm");
const LogoutModal = ({ translations, onCloseModal, onLogout }) => {
    return ((0, jsx_runtime_1.jsx)(Confirm_1.Confirm, { onCloseModal: onCloseModal, onConfirm: onLogout, translations: translations.confirmTranslations, children: (0, jsx_runtime_1.jsxs)(Content, { children: [(0, jsx_runtime_1.jsx)(IconWrapper, { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleBig", icon: ["fas", "exclamation-triangle"], color: "grey", size: "2x" }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: translations.proceeding }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: translations.areYouSure }, void 0)] }, void 0) }, void 0));
};
exports.LogoutModal = LogoutModal;
const IconWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  width: 100%;
`;
const Content = styled_components_1.default.div `
  h4:first-of-type {
    padding: ${({ theme }) => `${theme.spacings.xl} 0 ${theme.spacings.m}`};
  }

  h4:last-of-type {
    font-weight: 400;
    padding-bottom: ${({ theme }) => `${theme.spacings.xl}`};
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  }
`;
//# sourceMappingURL=Logout.js.map